import { Contact } from '~api/address_book';
import { Status as APIStatus } from '~api/som_search';

import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { Card, FormControl, PageWrapper } from '@ingrid/luterkort-react';

import { FormLeaveBlocker } from '~src/components/FormLeaveBlocker/FormLeaveBlocker';
import { MutationSaveBar } from '~src/components/MutationSaveBar/MutationSaveBar';
import { TrackingEventEnum, useTracking } from '~src/main/hooks/useTracking';

import { Addresses } from '../create/addresses';
import { AddressesProvider } from '../create/addresses-context';
import { CarrierContract } from '../create/carrier-contract';
import { CarrierProduct } from '../create/carrier-product';
import { CustomsDeclarations } from '../create/customs-declarations';
import { Metadata } from '../create/metadata';
import { Consignment } from '../details/consignment';
import { References } from '../details/references';
import { Status } from '../details/status';
import { useShipmentDetailsQuery } from '../queries';
import { useShipmentForm } from '../types';
import { Header } from './header';

export function EditPage() {
  const { id } = useParams();

  const shipment = useShipmentDetailsQuery({ id });
  const tracking = useTracking();

  const methods = useShipmentForm({ defaultValues: shipment });

  useEffect(() => {
    tracking.capture(TrackingEventEnum.ShipmentEditStart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (shipment.status.type !== 'CREATED' && shipment.status.type !== 'INVALID_BOOKING') {
    return null;
  }

  return (
    <PageWrapper gap="lg" variant="center" style={{ marginBottom: MutationSaveBar.Offset }}>
      <FormProvider {...methods}>
        <FormControl.Root>
          <Header />

          <AddressesProvider
            contacts={[
              shipment.contact_from,
              shipment.contact_to,
              shipment.contact_return,
              shipment.customer_info?.contact,
            ].filter((c): c is Contact => !!c)}
          >
            <Card.List>
              <Status status={shipment.status.type as APIStatus} />
              <References shipment={shipment} />
              <Addresses />
              <Consignment shipment={shipment} />
              <CustomsDeclarations />
              <CarrierProduct />
              <CarrierContract />
              <Metadata />
            </Card.List>
          </AddressesProvider>

          <FormLeaveBlocker formState={methods.formState} />
        </FormControl.Root>
      </FormProvider>
    </PageWrapper>
  );
}
